import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import { IncludeQuizHandler } from './include-quiz-handler';

export const quizFactoryModule = new ContainerModule(bind => {
  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeQuizHandler);
});
